export default __webpack_public_path__ + "static/media/PhantomSans0.8-Light.682ffc67.woff2";